import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class GTAUnknownCustNoHelper extends TKCustomElementFactory {
    form: HTMLFormElement |undefined;
    submitButton: HTMLButtonElement |undefined;

    constructor() {
        super();
        this.form = this.querySelector<HTMLFormElement>('[data-gta-unknown-custno-form]')
            || undefined;
        this.submitButton = this.querySelector<HTMLButtonElement>('[data-gta-submit-button]')
            || undefined;
    }

    connectedCallback(): void {
        this.registerFormSubmit();
        this.registerCheckboxChange();
    }

    registerFormSubmit() {
        if (!this.form) return;

        const formSubmitAction = this.onFormSubmit.bind(this);

        this.pushListener({
            event: 'submit',
            element: this.form,
            action: formSubmitAction,
        });
    }

    onFormSubmit(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (this.form!.checkValidity()) {
            this.removeRequiredAttribute();
            this.closeDialog();
        }
    }

    registerCheckboxChange() {
        const checkboxElement = this.querySelector('[data-gta-confirm-unknown-custno-cb]');

        if (!checkboxElement) throw new Error('Missing cb element');

        const cbChangeAction = this.onCbChanged.bind(this);

        this.pushListener({
            event: 'change',
            element: checkboxElement,
            action: cbChangeAction,
        });
    }

    onCbChanged(event: Event) {
        if (!this.submitButton) throw new Error('Missing submit button');
        this.submitButton.toggleAttribute('disabled', !(event.target as HTMLInputElement).checked);
    }

    // GTA-1154: remove required attribute
    // eslint-disable-next-line class-methods-use-this
    removeRequiredAttribute() {
        const custNoInput = document.querySelector('[data-gta-cust-no-input]');
        const formElement = custNoInput?.closest('tk-form-element');
        const labelElement = formElement?.querySelector('label');

        if (!custNoInput || !labelElement) throw new Error('Missing element');
        custNoInput.removeAttribute('required');
        labelElement.innerText = labelElement.innerText.replace('*', '').trim();
    }

    closeDialog() {
        const dialog = this.closest('dialog');
        dialog?.close();
    }
}
